import script from "./HasFiles.vue?vue&type=script&lang=ts"
export * from "./HasFiles.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__